import React from 'react';

import type { UUID } from '@aline/common';
import { Typography } from '@mui/material';
import { Sparkle, Trash2 } from 'lucide-react';
import { AlineAiAvatar } from 'src/components';
import { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';

import { ASSIGNEE_ROW_MENU_HOVER, AssigneeRowMenu } from './AssigneeRowMenu';

const useStyles = makeStyles()(theme => ({
  name: {
    color: theme.palette.text.primary,
    flex: 1,
    fontSize: 14,
    fontWeight: 600,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  row: {
    ...ASSIGNEE_ROW_MENU_HOVER,
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
  },
}));

interface TaskAiAssigneeRowProps {
  isReadOnly: boolean;
  taskId: UUID;
  editDisabledReason?: string | null;
}

/** Aline AI as an assignee. It runs when the task starts. */
export const TaskAiAssigneeRow = React.memo(function TaskAiAssigneeRow({
  editDisabledReason,
  isReadOnly,
  taskId,
}: TaskAiAssigneeRowProps) {
  const { classes } = useStyles();
  const [setTaskDelegatedToAi] = Apollo.useSetTaskDelegatedToAiMutation();

  return (
    <div className={classes.row}>
      <AlineAiAvatar styles={{ size: 'xs' }}>
        <Sparkle size={12} strokeWidth={2} />
      </AlineAiAvatar>
      <Typography className={classes.name}>Aline AI</Typography>
      {!isReadOnly && !editDisabledReason && (
        <AssigneeRowMenu
          items={[
            {
              icon: Trash2,
              isDestructive: true,
              label: 'Remove',
              onClick: () => void setTaskDelegatedToAi({ variables: { delegated: false, taskId } }),
            },
          ]}
          name="Aline AI"
        />
      )}
    </div>
  );
});
